<template>
  <div class="modal-container pt-0 px-0">
    <div class="row">
      <div
        class="col-md-12 justify-content-end float-right modal-header px-5 align-items-center"
      >
        <div class="header-container row justify-content-between">
          <span class="empty-space" />
          <div class="category-name-container">
            <h3 class="text-center">{{ subCategory.name }}</h3>
          </div>
          <button class="close close-btn" @click="closeModal">
            <font-awesome-icon icon="times" />
          </button>
        </div>
      </div>
    </div>
    <div class="row justify-content-center pt-4 solution-container ">
      <span class="main-title">{{ title }}</span>
      <div class="col-12 mt-4 px-5">
        <div class="row justify-content-around px-5 flex-wrap">
          <div
            class="solution-target-card d-flex flex-column justify-content-center align-items-center py-3 px-4"
            v-for="(target, key) in currentSolution.targets"
            :key="key"
            :class="columnSize"
          >
            <img src="@/assets/images/icon-articles.svg" alt="lightning icon" />
            <a class="solution-link pt-2" @click="onSolutionClicked(target,$event)" :href="target.linkValue">
              {{ target.linkName }} <font-awesome-icon
                    v-if="target.openLinkInNewTab"
                    class="ml-1"
                    icon="external-link-alt"
            />
            </a>
            <p
              v-if="checkTargetDescription(target.description)"
              class="solution-description mt-3"
              v-html="target.description"
            ></p>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col-12 text-center question-span">
            <span class="font-weight-bold" v-if="currentAppData.solutionFooterTemplate && currentAppData.solutionFooterTemplate.solutionFooterValues">
              <span v-for="(solutionFooter,index) in currentAppData.solutionFooterTemplate.solutionFooterValues" :key="index">
                {{solutionFooter.linkPrefix}} <a :href="solutionFooter.linkValue"  @click="trackSupportPageClick(searchPageName)" target="_parent">{{solutionFooter.linkName}}</a>{{solutionFooter.linkSuffix}}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppMixin from "../mixins/AppMixin";
import CONSTANTS from "@/store/constants";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "ModalSolutions",
  props: ["subCategory"],
  mixins: [AppMixin],
  created() {
    this.setSearchResult(null);
  },
  data() {
    return {
      supportPageName: "Support",
      searchPageName: "Search",
    };
  },
  computed: {
    ...mapGetters(["isComponentRequest","currentAppData"]),
    supportUrl(){
      return this.ehUrl + CONSTANTS.SUPPORT_URL;
    },
    searchUrl(){
      return this.ehUrl + CONSTANTS.SEARCH_URL;
    },
    ehUrl(){
      if(this.isComponentRequest){
        return CONSTANTS.EH_BASE_URL;
      }
      return CONSTANTS.EH_URL;

    },

    title() {
      let pluralChar =
        this.currentSolution.targets && this.currentSolution.targets.length > 1
          ? "s"
          : "";
      let titleText = `We found ${this.currentSolution.targets.length} solution${pluralChar} that can help:`;
      return titleText;
    },
    checkTargetDescription() {
      return (description) => description && description.length;
    },
    currentSolution() {
      let subCategory = [];
      if (this.subCategory.solutions && this.subCategory.solutions[0]) {
        subCategory = this.subCategory.solutions[0];
      }
      return subCategory;
    },
    columnSize() {
      let gridSize = this.currentSolution.targets.length >= 4 ? 20 : 10;
      let columnCalc = Math.ceil(
        gridSize / this.currentSolution.targets.length
      );
      return `col-${columnCalc} my-3`;
    },
  },
  methods: {
    ...mapMutations(["setSearchResult"]),
    closeModal() {
      this.$nextTick(() => {
        this.$emit("close");
      });
    },
    trackSupportPageClick(pageName) {
      this.trackEvent(
        null,
        `Solution not found: ${pageName} page clicked - ${this.subCategory.name}`
      );
    },
  },
};
</script>
<style>
  @media (max-width: 768px) {
    .app-modal {
      overflow-y: auto !important;
    }
  }
  .tall-modal{
    overflow-y: auto !important;
  }
</style>
<style scoped>
.question-span {
  font-size: 16px;
}
.header-container {
  width: 100%;
}

.empty-space {
  width: 10%;
}

.modal-header {
  background: #000000;
  border: none;
  height: 85px;
}

.modal-header h3 {
  font-size: 21px;
  color: #fff;
  margin: 0;
}

.main-title {
  text-align: center;
  font-size: 20px;
}

.category-name-container {
  width: 80%;
}
.category-name-container h3 {
  font-size: 26px;
}

.modal-container {
  background: #fff;
  min-height: 550px;
  padding: 30px;
}


.solution-target-card {
  background: #f0faff;
  min-height: 160px;
  min-width: 305px !important;
}

.solution-target-card img {
  width: 25px;
  height: 25px;
}

.solution-link {
  text-align: center;
  font-size: 16px;
}
.solution-description {
  font-size: 12px;
  color: #000;
  text-align: center;
  max-width: 100%;
}

.close-btn {
  outline: none;
  cursor: pointer;
  width: 10%;
}

.close-btn svg {
  color: #fff;
}
</style>
